/*
 * @Auther: 罗耀祖
 * @Date: 2022-02-14 10:01:55
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-05-30 10:08:43
 * @name: 通用模块控制器
 * @Description: 通用模块控制器
 * @FilePath: \project\src\module\common\common.controller.js
 * @Author: desktop
 */
import { Controller, Get, Post, Validator } from "@/nestVue/common";
@Controller('common')
class commonController {
  constructor() {

  }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: 发送验证码
   */
  @Validator(require('./validator/verify').validator, { toastError: true })
  @Post('verify.html', { showLoading: true, toastSuccess: true, successMsg: '短信发送成功' })
  verify(ctx) { }

  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: 获取oss token
   */
  @Get('getUploadStsToken.html', { showLoading: false, toastSuccess: false, successMsg: 'oss token获取成功' })
  getUploadStsToken(ctx) { }
}
export default commonController;